"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductsScreen = ProductsScreen;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("react");
var react_router_dom_1 = require("react-router-dom");
var confirm_dialog_1 = require("../../components/common/confirm-dialog");
var data_table_1 = require("../../components/common/data-table");
var page_header_1 = require("../../components/common/page-header");
var permission_gate_1 = require("../../components/common/permission-gate");
var search_input_1 = require("../../components/common/search-input");
var status_badge_1 = require("../../components/common/status-badge");
var products_1 = require("../../features/apis/products");
var use_error_handler_1 = require("../../hooks/use-error-handler");
var permissions_1 = require("../../interfaces/permissions");
function PlusIcon() {
    return ((0, jsx_runtime_1.jsx)("svg", { className: "h-4 w-4", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: (0, jsx_runtime_1.jsx)("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M12 4v16m8-8H4" }) }));
}
function ProductsScreen() {
    var _this = this;
    var _a, _b, _c;
    var navigate = (0, react_router_dom_1.useNavigate)();
    var _d = (0, use_error_handler_1.useErrorHandler)(), handleError = _d.handleError, handleSuccess = _d.handleSuccess;
    var _e = (0, react_2.useState)(1), page = _e[0], setPage = _e[1];
    var _f = (0, react_2.useState)(""), search = _f[0], setSearch = _f[1];
    var _g = (0, react_2.useState)(""), networkFilter = _g[0], setNetworkFilter = _g[1];
    var _h = (0, react_1.useDisclosure)(), isDeleteOpen = _h.isOpen, onDeleteOpen = _h.onOpen, onDeleteClose = _h.onClose;
    var _j = (0, react_2.useState)(null), deletingProduct = _j[0], setDeletingProduct = _j[1];
    var _k = (0, products_1.useGetProductsQuery)({
        page: page,
        limit: 10,
        search: search || undefined,
        network: networkFilter || undefined,
    }), data = _k.data, isLoading = _k.isLoading, isFetching = _k.isFetching;
    var _l = (0, products_1.useDeleteProductMutation)(), deleteProduct = _l[0], isDeleting = _l[1].isLoading;
    var _m = (0, products_1.useEnableProductMutation)(), enableProduct = _m[0], isEnabling = _m[1].isLoading;
    var _o = (0, products_1.useDisableProductMutation)(), disableProduct = _o[0], isDisabling = _o[1].isLoading;
    var products = ((_a = data === null || data === void 0 ? void 0 : data.content) === null || _a === void 0 ? void 0 : _a.products) || [];
    var totalPages = ((_c = (_b = data === null || data === void 0 ? void 0 : data.content) === null || _b === void 0 ? void 0 : _b.pagination) === null || _c === void 0 ? void 0 : _c.total_pages) || 1;
    var columns = [
        {
            key: "name",
            label: "Name",
            render: function (item) { return (0, jsx_runtime_1.jsx)("span", { className: "font-medium text-foreground", children: item.name }); },
        },
        {
            key: "network",
            label: "Network",
            render: function (item) { return (0, jsx_runtime_1.jsx)("span", { className: "text-default-500", children: item.network }); },
        },
        {
            key: "product_type",
            label: "Type",
            render: function (item) { return ((0, jsx_runtime_1.jsx)("span", { className: "rounded-full px-2 py-0.5 text-xs font-medium ".concat(item.product_type === "bundle" ? "bg-purple-100 text-purple-700" : "bg-orange-100 text-orange-700"), children: item.product_type === "bundle" ? "Bundle" : "Airtime" })); },
        },
        {
            key: "value",
            label: "Value",
            render: function (item) {
                var _a;
                if (item.product_type === "bundle") {
                    return (0, jsx_runtime_1.jsx)("span", { className: "font-medium text-purple-600", children: item.bundle_description || "Bundle" });
                }
                var valueCents = (_a = item.value_cents) !== null && _a !== void 0 ? _a : item.denomination;
                return (0, jsx_runtime_1.jsxs)("span", { className: "font-medium", children: ["N$", (valueCents / 100).toFixed(2)] });
            },
        },
        {
            key: "validity_days",
            label: "Validity",
            render: function (item) { return (0, jsx_runtime_1.jsxs)("span", { className: "text-default-500", children: [item.validity_days, " days"] }); },
        },
        {
            key: "status",
            label: "Status",
            render: function (item) { return (0, jsx_runtime_1.jsx)(status_badge_1.StatusBadge, { status: item.status }); },
        },
        {
            key: "actions",
            label: "Actions",
            align: "end",
            render: function (item) { return ((0, jsx_runtime_1.jsxs)("div", { className: "flex justify-end gap-2", children: [(0, jsx_runtime_1.jsx)(permission_gate_1.PermissionGate, { module: permissions_1.MODULES.PRODUCTS, action: permissions_1.ACTIONS.UPDATE, children: (0, jsx_runtime_1.jsx)(react_1.Button, { size: "sm", variant: "light", color: "primary", onPress: function () { return navigate("/products/".concat(item._id, "/edit")); }, children: "Edit" }) }), (0, jsx_runtime_1.jsx)(permission_gate_1.PermissionGate, { module: permissions_1.MODULES.PRODUCTS, action: permissions_1.ACTIONS.UPDATE, children: item.status === "active" ? ((0, jsx_runtime_1.jsx)(react_1.Button, { size: "sm", variant: "light", color: "warning", isLoading: isDisabling, onPress: function () { return handleToggleStatus(item, false); }, children: "Disable" })) : ((0, jsx_runtime_1.jsx)(react_1.Button, { size: "sm", variant: "light", color: "success", isLoading: isEnabling, onPress: function () { return handleToggleStatus(item, true); }, children: "Enable" })) }), (0, jsx_runtime_1.jsx)(permission_gate_1.PermissionGate, { module: permissions_1.MODULES.PRODUCTS, action: permissions_1.ACTIONS.DELETE, children: (0, jsx_runtime_1.jsx)(react_1.Button, { size: "sm", variant: "light", color: "danger", onPress: function () {
                                setDeletingProduct(item);
                                onDeleteOpen();
                            }, children: "Delete" }) })] })); },
        },
    ];
    var handleDelete = function () { return __awaiter(_this, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!deletingProduct)
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, deleteProduct(deletingProduct._id).unwrap()];
                case 2:
                    _a.sent();
                    handleSuccess("Product deleted successfully");
                    onDeleteClose();
                    setDeletingProduct(null);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    handleError(error_1, { defaultMessage: "Failed to delete product" });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleToggleStatus = function (product, enable) { return __awaiter(_this, void 0, void 0, function () {
        var error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 5, , 6]);
                    if (!enable) return [3 /*break*/, 2];
                    return [4 /*yield*/, enableProduct(product._id).unwrap()];
                case 1:
                    _a.sent();
                    handleSuccess("Product \"".concat(product.name, "\" enabled successfully"));
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, disableProduct(product._id).unwrap()];
                case 3:
                    _a.sent();
                    handleSuccess("Product \"".concat(product.name, "\" disabled successfully"));
                    _a.label = 4;
                case 4: return [3 /*break*/, 6];
                case 5:
                    error_2 = _a.sent();
                    handleError(error_2, { defaultMessage: "Failed to ".concat(enable ? "enable" : "disable", " product") });
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "space-y-6", children: [(0, jsx_runtime_1.jsx)(page_header_1.PageHeader, { title: "Products", description: "Manage airtime products", actions: [
                    {
                        label: "Add Product",
                        icon: (0, jsx_runtime_1.jsx)(PlusIcon, {}),
                        href: "/products/new",
                    },
                ] }), (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-wrap items-center gap-4", children: [(0, jsx_runtime_1.jsx)(search_input_1.SearchInput, { placeholder: "Search products...", value: search, onChange: setSearch, className: "w-64" }), (0, jsx_runtime_1.jsxs)("select", { value: networkFilter, onChange: function (e) { return setNetworkFilter(e.target.value); }, className: "h-8 w-40 rounded-lg border border-default-300 bg-default-100 px-2 text-sm text-foreground outline-none transition-colors hover:bg-default-200 focus:border-primary", children: [(0, jsx_runtime_1.jsx)("option", { value: "", children: "All Networks" }), (0, jsx_runtime_1.jsx)("option", { value: "MTC", children: "MTC" })] })] }), (0, jsx_runtime_1.jsx)(data_table_1.DataTable, { columns: columns, data: products, isLoading: isLoading || isFetching, page: page, totalPages: totalPages, onPageChange: setPage, emptyContent: "No products found" }), (0, jsx_runtime_1.jsx)(confirm_dialog_1.ConfirmDialog, { isOpen: isDeleteOpen, onClose: onDeleteClose, onConfirm: handleDelete, title: "Delete Product", message: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Are you sure you want to permanently delete ", (0, jsx_runtime_1.jsx)("strong", { children: deletingProduct === null || deletingProduct === void 0 ? void 0 : deletingProduct.name }), "? This action cannot be undone.", (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("span", { className: "text-xs text-default-400", children: "Note: Products with existing vouchers cannot be deleted. Use \"Disable\" to deactivate the product instead." })] }), confirmLabel: "Delete Permanently", confirmColor: "danger", isLoading: isDeleting })] }));
}
